import React, { memo } from 'react';
import moment from 'moment';
import { format } from 'date-fns';

const RdvSection = memo(({ dailyAppointments, tooltip, onShowTooltip, onHideTooltip, stripHtml }) => {
  return (
    <div className="rdv">
      <label className="titrerdv">Rendez-vous</label>
      <div className="allRDVs">
        {dailyAppointments.length > 0 ? (
          dailyAppointments.map((rdv, i) => (
            <p key={i} onMouseOver={(e) => onShowTooltip(e, rdv)} onMouseOut={onHideTooltip}>
              {rdv.id ? (
                <>
                  {rdv.ndossier + ' - '}
                  <span className="rdv-type">{rdv.type}</span>
                  {rdv.lot?.trim() && <span className="rdv-lot">{rdv.lot}</span>}
                  <span className="rdv-time">{moment.utc(rdv.start).format('HH:mm')}</span>
                </>
              ) : (
                <>
                  <span className="rdv-title">
                    {rdv.title?.length > 20 ? rdv.title.slice(0, 20) + '...' : rdv.title}
                  </span>
                  {rdv.description?.trim() && (
                    <span className="rdv-description">
                      {stripHtml(rdv.description).slice(0, 20)}...
                    </span>
                  )}
                  <span className="rdv-time">{format(new Date(rdv.start), 'HH:mm')}</span>
                </>
              )}
            </p>
          ))
        ) : (
          <p className="no-rdv">Aucun rendez-vous prévu.</p>
        )}
      </div>
      {tooltip.visible && (
        <div
          className="tooltip"
          style={{ left: tooltip.x, top: tooltip.y - 20 }}
          dangerouslySetInnerHTML={{ __html: tooltip.content }}
        />
      )}
    </div>
  );
});

RdvSection.displayName = 'RdvSection';

export default RdvSection;